// 引入cookie-js
import 'core-js/stable/promise';  // 新版路径（core-js@3+）
import Cookie from 'js-cookie'

import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	routes: [{
			path: '/',
			component: resolve => require(['@/views/info/index'], resolve),
			children: [{
				path: '/',
				meta: {
					title: '帮百姓 助万家'
				},
				component: resolve => require(['@/views/info/home'], resolve)
			}, {
				path: '/lists/',
				meta: {
					title: '信息列表'
				},
				component: resolve => require(['@/views/info/lists'], resolve)
			}, {
				path: '/lists/:pid',
				meta: {
					title: '信息列表'
				},
				component: resolve => require(['@/views/info/lists'], resolve)
			}, {
				path: '/detail/:id',
				meta: {
					title: '信息详情'
				},
				component: resolve => require(['@/views/info/detail'], resolve)
			}]
		},
		{
			path: '/regist/index',
			meta: {
				title: '会员注册'
			},
			 component: resolve => require(['@/views/regist/index'], resolve)
		},
		{
			path: '/regist/refound',
			meta: {
				title: '找回密码'
			},
			 component: resolve => require(['@/views/regist/refound'], resolve)
		},
		{
			path: '/member/',
			meta: {
				title: '用户中心',
				requireMemberAuth: true
			},
			component: resolve => require(['@/views/member/index'], resolve),
			children: [{
					path: '/member/',
					meta: {
						title: '首页',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/home'], resolve)
				}, {
					path: '/member/profile',
					meta: {
						title: '实名认证',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/profile'], resolve)
				}, {
					path: '/member/account',
					meta: {
						title: '我的帐户',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/account'], resolve)
				}, {
					path: '/member/info/lists',
					meta: {
						title: '信息管理',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/info/lists'], resolve)
				}, {
					path: '/member/info/add',
					meta: {
						title: '信息发布',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/info/add'], resolve)
				}, {
					path: '/member/info/add/:id',
					meta: {
						title: '信息发布',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/info/add'], resolve)
				}, {
					path: '/member/job/lists',
					meta: {
						title: '招聘管理',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/job/lists'], resolve)
				}, {
					path: '/member/job/add',
					meta: {
						title: '招聘发布',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/job/add'], resolve)
				},
				{
					path: '/member/job/resume',
					meta: {
						title: '简历列表',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/job/resume'], resolve)
				},

				{
					path: '/member/job/add/:id',
					meta: {
						title: '招聘发布',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/job/add'], resolve)
				},
				{
					path: '/member/resume',
					meta: {
						title: '我的简历',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/resume'], resolve)
				}, {
					path: '/member/resume/:id',
					meta: {
						title: '我的简历',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/resume'], resolve)
				}, {
					path: '/member/house/lists',
					meta: {
						title: '房产管理',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/house/lists'], resolve)
				}, {
					path: '/member/house/add',
					meta: {
						title: '房产发布',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/house/add'], resolve)
				}, {
					path: '/member/house/add/:id',
					meta: {
						title: '房产发布',
						requireMemberAuth: true
					},
					component: resolve => require(['@/views/member/house/add'], resolve)
				}
			]
		}, {
			path: '/job/',
			component: resolve => require(['@/views/job/index'], resolve),
			children: [{
					path: '/job/',
					meta: {
						title: '招聘求职'
					},
					component: resolve => require(['@/views/job/home'], resolve)
				},

				{
					path: '/job/lists/',
					meta: {
						title: '招聘列表'
					},
					component: resolve => require(['@/views/job/lists'], resolve)
				}, {
					path: '/job/lists/:pid',
					meta: {
						title: '招聘列表'
					},
					component: resolve => require(['@/views/job/lists'], resolve)
				}, {
					path: '/job/detail/:id',
					meta: {
						title: '信息详情'
					},
					component: resolve => require(['@/views/job/detail'], resolve)
				}, {
					path: '/job/company/',
					meta: {
						title: '招聘名企'
					},
					component: resolve => require(['@/views/job/company'], resolve)
				}, {
					path: '/job/company/detail/:uid',
					meta: {
						title: '名企展示'
					},
					component: resolve => require(['@/views/job/company_detail'], resolve)
				}
			]
		},
		{
			path: '/paper/',
			component: resolve => require(['@/views/paper/index'], resolve),
			children: [{
					path: '/paper/',
					meta: {
						title: '电子报'
					},
					component: resolve => require(['@/views/paper/lists'], resolve)
				},

				{
					path: '/paper/detail/:id',
					meta: {
						title: '电子报'
					},
					component: resolve => require(['@/views/paper/detail'], resolve)
				},
			],
		},
		{
			path: '/house/',
			component: resolve => require(['@/views/house/index'], resolve),
			children: [{
					path: '/house/',
					meta: {
						title: '房产'
					},
					component: resolve => require(['@/views/house/home'], resolve)
				},
				// {
				// 	path: '/house/lists/:cid',
				// 	meta: {
				// 		title: '房产列表'
				// 	},
				// 	component: resolve => require(['@/views/house/lists'], resolve)
				// }, 
				{
					path: '/house/lists/:pid',
					meta: {
						title: '房产列表'
					},
					component: resolve => require(['@/views/house/lists'], resolve)
				}, {
					path: '/house/detail/:id',
					meta: {
						title: '房产详情'
					},
					component: resolve => require(['@/views/house/detail'], resolve)
				}, {
					path: '/house/agency/',
					meta: {
						title: '中介机构'
					},
					component: resolve => require(['@/views/house/agency'], resolve)
				}, {
					path: '/house/agency/:page',
					meta: {
						title: '中介机构'
					},
					component: resolve => require(['@/views/house/agency'], resolve)
				}, {
					path: '/house/detail_agency/:id',
					meta: {
						title: '中介机构'
					},
					component: resolve => require(['@/views/house/detail_agency'], resolve)
				}, {
					path: '/house/village/',
					meta: {
						title: '小区楼盘'
					},
					component: resolve => require(['@/views/house/village'], resolve)
				}, {
					path: '/house/village/:page',
					meta: {
						title: '小区楼盘'
					},
					component: resolve => require(['@/views/house/village'], resolve)
				}, {
					path: '/house/detail/:id',
					meta: {
						title: '房产详情'
					},
					component: resolve => require(['@/views/house/detail_village'], resolve)
				}
			]
		},
		{
			path: '/manage/login/',
			meta: {
				title: '管理登录'
			},
			component: resolve => require(['@/views/manage/login'], resolve)
		},
		{
			path: '/manage/',
			meta: {
				requireAuth: true
			},
			component: resolve => require(['@/views/manage/index'], resolve),
			children: [{
					path: '/manage/',
					meta: {
						title: '管理后台',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/home'], resolve)
				}, {
					path: '/manage/member/lists',
					meta: {
						title: '会员管理',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/member/lists'], resolve)
				},
				{
					path: '/manage/member/deal',
					meta: {
						title: '充值信息',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/member/deal'], resolve)
				}, {
					path: '/manage/member/resume',
					meta: {
						title: '会员简历',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/member/resume'], resolve)
				}, {
					path: '/manage/member/group',
					meta: {
						title: '会员角色',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/member/group'], resolve)
				}, {
					path: '/manage/member/menu',
					meta: {
						title: '会员权限',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/member/menu'], resolve)
				}, {
					path: '/manage/setting/index',
					meta: {
						title: '系统设置',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/setting/index'], resolve)
				}, {
					path: '/manage/setting/region',
					meta: {
						title: '地区管理',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/setting/region'], resolve)
				},
				{
					path: '/manage/admin/lists',
					meta: {
						title: '管理人员',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/admin/lists'], resolve)
				},
				{
					path: '/manage/admin/group',
					meta: {
						title: '管理角色',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/admin/group'], resolve)
				},
				{
					path: '/manage/admin/menu',
					meta: {
						title: '管理权限',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/admin/menu'], resolve)
				}, {
					path: '/manage/info/lists',
					meta: {
						title: '信息管理',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/info/lists'], resolve)
				}, {
					path: '/manage/info/add',
					meta: {
						title: '信息添加',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/info/add'], resolve)
				}, {
					path: '/manage/info/add/:id',
					meta: {
						title: '信息管理',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/info/add'], resolve)
				}, {
					path: '/manage/info/class',
					meta: {
						title: '信息添加',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/info/class'], resolve)
				}, {
					path: '/manage/job/lists',
					meta: {
						title: '招聘管理',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/job/lists'], resolve)
				}, {
					path: '/manage/job/resume',
					meta: {
						title: '简历管理',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/job/resume'], resolve)
				}, {
					path: '/manage/job/add',
					meta: {
						title: '发布岗位',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/job/add'], resolve)
				}, {
					path: '/manage/job/add/:id',
					meta: {
						title: '发布岗位',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/job/add'], resolve)
				}, {
					path: '/manage/job/class',
					meta: {
						title: '招聘岗位',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/job/class'], resolve)
				}, {
					path: '/manage/house/lists',
					meta: {
						title: '房产管理',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/house/lists'], resolve)
				}, {
					path: '/manage/house/class',
					meta: {
						title: '房产分类',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/house/class'], resolve)
				}, {
					path: '/manage/house/add',
					meta: {
						title: '发布房产',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/house/add'], resolve)
				}, {
					path: '/manage/house/add/:id',
					meta: {
						title: '发布房产',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/house/add'], resolve)
				}, {
					path: '/manage/house/tag',
					meta: {
						title: '房产标签',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/house/tag'], resolve)
				}, {
					path: '/manage/advert/lists',
					meta: {
						title: '广告管理',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/advert/lists'], resolve)
				}, {
					path: '/manage/paper/lists',
					meta: {
						title: '电子报纸',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/paper/lists'], resolve)
				}, {
					path: '/manage/paper/add',
					meta: {
						title: '发布报纸',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/paper/add'], resolve)
				}, {
					path: '/manage/paper/add/:id',
					meta: {
						title: '编辑报纸',
						requireAuth: true
					},
					component: resolve => require(['@/views/manage/paper/add'], resolve)
				}
			]
		}
	]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

// 导航守卫
router.beforeEach((to, from, next) => {
	if (to.meta.requireAuth == true) { // 判断该路由是否需要登录权限
		let admin = Cookie.get('admin')
		if (admin === undefined || admin === 'e30=' || !admin) { // cookie是否存在
			next({
				path: '/manage/login/' // 跳转到登录界面
			})
		} else {
			next()
		}
	} else {
		next()
	}
})

export default router